module.exports = __webpack_public_path__ + "media/images/area/area_oitaM400-edb00addbfcf8722cfa551ac7e4f07fe.jpg";